// reactstrap components
import { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";
import { getApiDataService } from "services/apiServices";
import { REPORT, MOVE_REPORT, SMS_BALANCE } from "services/CONSTANTS";

const formatStat = (value) => value?.toLocaleString("en-US") ?? "—";

const Header = () => {
  const [reports, setReports] = useState(null);
  const [moveReports, setMoveReports] = useState(null);
  const [currentSmsBalance, setCurrentSmsBalance] = useState(0);
  useEffect(() => {
    getApiDataService(MOVE_REPORT)
      .then((res) => {
        setMoveReports(res);
      })
      .catch(() => {});

    // Restores dashboard wallet/deposit stats (endpoint still healthy; was commented out in 2023).
    getApiDataService(REPORT)
      .then((res) => {
        setReports(res?.data ?? res);
      })
      .catch(() => {});

    getApiDataService(SMS_BALANCE)
      .then((res) => {
        const credits =
          typeof res === "object" && res !== null
            ? res?.data?.credits ?? res?.credits
            : 0;
        setCurrentSmsBalance(credits ?? 0);
      })
      .catch(() => {
        setCurrentSmsBalance(0);
      });
  }, []);

  const stats = [
    {
      label: "Active Users",
      value: moveReports?.total_new_user,
      icon: "fas fa-users",
      color: "bg-primary",
    },
    {
      label: "SMS Balance",
      value: currentSmsBalance,
      icon: "fas fa-sms",
      color: "bg-info",
    },
    {
      label: "Total Users",
      value: moveReports?.total_user,
      icon: "fas fa-user-plus",
      color: "bg-danger",
    },
    {
      label: "Today Deposit",
      value: reports?.today_deposit,
      icon: "fas fa-wallet",
      color: "bg-accent",
    },
    {
      label: "New Deposit",
      value: reports?.today_pending_deposit,
      icon: "fas fa-plus-circle",
      color: "bg-info",
    },
    {
      label: "Today Profit",
      value: reports?.today_profit,
      icon: "fas fa-chart-line",
      color: "bg-success",
    },
    {
      label: "Total MMK",
      value: reports?.total_mmk,
      icon: "fas fa-money-bill-wave",
      color: "bg-primary",
    },
    {
      label: "Total THB",
      value: reports?.total_thb,
      icon: "fas fa-coins",
      color: "bg-accent",
    },
  ];

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              {stats.map((stat) => (
                <Col className="mb-4" lg="6" xl="3" key={stat.label}>
                  <Card className="card-stats h-100">
                    <CardBody>
                      <Row className="align-items-center">
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            {stat.label}
                          </CardTitle>
                          <span className="h2 font-weight-bold font-mono mb-0">
                            {formatStat(stat.value)}
                          </span>
                        </div>
                        <Col className="col-auto">
                          <div
                            className={`icon icon-shape ${stat.color} text-white rounded-circle shadow`}
                          >
                            <i className={stat.icon} />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
